import { render, staticRenderFns } from "./Monthlive.vue?vue&type=template&id=c243845a&"
import script from "./Monthlive.vue?vue&type=script&lang=js&"
export * from "./Monthlive.vue?vue&type=script&lang=js&"
import style0 from "./Monthlive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../crossBorder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports